import { useState } from "react";
import {
  Activity, Baby, CalendarCheck, CalendarDays, ClipboardCheck, ClipboardList, FolderKanban, GraduationCap,
  HandHeart, House, ListMusic, Send, Settings, Shuffle, Star, UserMinus, UserPlus, Users, Vote, X,
} from "lucide-react";
import { menuDe } from "../../features/auth/secciones";
import CambiarPassword from "../../shared/components/CambiarPassword";
import Marca from "../../shared/components/Marca";

// Ícono de cada sección del menú (ids de features/auth/secciones.js).
const ICONOS = {
  dashboard: House,
  mis_turnos: CalendarCheck,
  reuniones: CalendarDays,
  programacion: ListMusic,
  asistencia: ClipboardCheck,
  servidores: HandHeart,
  miembros: Users,
  familias: House,
  visitas_nuevas: UserPlus,
  permanencia: Activity,
  bajas: UserMinus,
  kids_programacion: Shuffle,
  ninos: Baby,
  asistencia_ninos: ClipboardList,
  calificaciones: Star,
  cursos: GraduationCap,
  notificaciones: Send,
  encuestas: Vote,
  proyectos: FolderKanban,
  configuracion: Settings,
};

const iniciales = (nombre) =>
  (nombre || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join("");

// En computador el menú está siempre a la izquierda; en celular y tableta se abre
// desde el botón "Menú" de la barra superior y se cierra al elegir una sección.
function Sidebar({ seccionActiva, setSeccion, onLogout, usuario, abierto = false, onCerrar = () => {} }) {
  const nombre = usuario?.miembro ? `${usuario.miembro.nombres} ${usuario.miembro.apellidos}` : usuario?.username;
  // Cada rol ve solo las secciones que tiene permitidas.
  const menu = menuDe(usuario);
  const [cambiandoClave, setCambiandoClave] = useState(false);

  return (
    <>
    {abierto && <div className="fixed inset-0 z-30 bg-black/70 lg:hidden" onClick={onCerrar} aria-hidden="true" />}
    <aside
      className={`fixed left-0 top-0 z-40 flex h-screen w-64 flex-col border-r border-white/10 bg-black transition-transform duration-200 lg:translate-x-0 ${
        abierto ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center justify-between border-b border-white/10 px-6 py-5">
        <Marca />
        <button onClick={onCerrar} aria-label="Cerrar menú" className="rounded-full p-1 text-gray-500 transition hover:bg-white/10 hover:text-white lg:hidden">
          <X size={18} aria-hidden="true" />
        </button>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4" aria-label="Menú principal">
        {menu.map(({ grupo, opciones }, i) => (
          <div key={grupo || `suelto-${i}`} className={i ? "mt-3 border-t border-white/5 pt-3" : ""}>
            {grupo && <p className="mb-1.5 px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-600">{grupo}</p>}
            {opciones.map((item) => {
              const Icono = ICONOS[item.id];
              const activa = seccionActiva === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => { setSeccion(item.id); onCerrar(); }}
                  aria-current={activa ? "page" : undefined}
                  className={`group mb-0.5 flex w-full items-center gap-3 rounded-full px-4 py-2 text-left text-xs font-bold uppercase tracking-[0.08em] transition-all duration-200 ${
                    activa ? "bg-white text-black shadow-lg shadow-white/10" : "text-gray-400 hover:bg-white/5 hover:text-white"
                  }`}
                >
                  {Icono && (
                    <Icono
                      size={16}
                      strokeWidth={2}
                      aria-hidden="true"
                      className={`shrink-0 transition-transform duration-200 ${activa ? "" : "group-hover:scale-110"}`}
                    />
                  )}
                  <span className="truncate">{item.label}</span>
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="border-t border-white/10 p-4">
        {usuario && (
          <div className="mb-4 flex items-center gap-3 px-1">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 bg-zinc-800 text-[11px] font-bold uppercase text-white" aria-hidden="true">
              {iniciales(nombre)}
            </span>
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-white">{nombre}</p>
              <p className="truncate text-[11px] text-gray-500">{usuario.rol?.nombre || (usuario.acceso?.total ? "Acceso total" : usuario.perfil)}</p>
            </div>
          </div>
        )}
        <div className="space-y-2">
          <button onClick={() => setCambiandoClave(true)} className="btn-fantasma btn-sm w-full border-white/10 text-gray-400">
            Cambiar contraseña
          </button>
          <button onClick={onLogout} className="btn-fantasma btn-sm w-full">
            Cerrar sesión
          </button>
        </div>
      </div>
      {cambiandoClave && <CambiarPassword onCerrar={() => setCambiandoClave(false)} />}
    </aside>
    </>
  );
}

export default Sidebar;
